import baseFetch from '../baseFetch';

// eslint-disable-next-line import/prefer-default-export
export const fetchWorldTaxonomy = () => baseFetch('/location/view/worldtaxonomy?');



// WEBPACK FOOTER //
// ./src/common/api/location.js